import {
  attachServiceImages,
  siteContentEs,
  siteContentEn,
} from '../i18n/siteContent';
import { ORTHO_TREATMENT_ITEMS } from '../data/orthoTreatmentItems';
import { MAXILLARY_TREATMENT_ITEMS } from '../data/maxillaryTreatmentItems';
import { orthoPagePath } from '../data/orthoMenuPages';
import { translate, DEFAULT_LOCALE } from '../i18n/translations';

function localeContent(locale) {
  return locale === 'en' ? siteContentEn : siteContentEs;
}

export function getServiceData(locale, { excludePageIds = [] } = {}) {
  const excluded = new Set(excludePageIds);
  const items = ORTHO_TREATMENT_ITEMS.filter(({ pageId }) => !excluded.has(pageId)).map(
    ({ pageId, imageId }) => ({
    pageId,
    id: imageId,
    title: translate(locale, `navMega.orthodontics.${pageId}`),
    description: translate(locale, `navMega.orthodontics.${pageId}Desc`),
    to: orthoPagePath(pageId),
  })
  );

  return attachServiceImages(items);
}

export function getMaxillaryServiceData(locale) {
  const items = MAXILLARY_TREATMENT_ITEMS.map(({ pageId, imageId }) => ({
    pageId,
    id: imageId,
    title: translate(locale, `navMega.maxillaryOrtho.${pageId}`),
    description: translate(locale, `navMega.maxillaryOrtho.${pageId}Desc`),
    to: orthoPagePath(pageId),
  }));

  return attachServiceImages(items);
}

export function getTreatmentTitlesForBooking(locale) {
  return localeContent(locale).services.bookingTreatments;
}

export function formatTreatmentShortLabel(full, locale = DEFAULT_LOCALE, maxLen = 30) {
  const t = String(full || '').replace(/\s+/g, ' ').trim();
  if (!t) return translate(locale, 'services.treatmentUnspecified');

  const treatmentTitlesForBooking = getTreatmentTitlesForBooking(locale);
  const found = treatmentTitlesForBooking.find(
    (o) => String(o.title || '').replace(/\s+/g, ' ').trim() === t
  );
  if (found?.shortTitle) return found.shortTitle;

  if (t.length <= maxLen) return t;

  const beforeSlash = String(t.split('/')[0])
    .replace(/\s+/g, ' ')
    .trim()
    .replace(/^Tratamiento de /i, '')
    .replace(/^Orthodontic treatment /i, '');
  if (beforeSlash && beforeSlash.length <= maxLen) return beforeSlash;

  return `${t.slice(0, maxLen - 1).trim()}…`;
}

/** @deprecated Use getServiceData(locale) */
const ServiceData = getServiceData(DEFAULT_LOCALE);

export const treatmentTitlesForBooking = getTreatmentTitlesForBooking(DEFAULT_LOCALE);

export default ServiceData;
